import { gql } from '@apollo/client'

const ADDRESSES = gql`
  query addressAutoFills {
    addressAutoFills {
      edges {
        node {
          id
          address
        }
      }
    }
  }
`

const CITIES = gql`
  query cityAutoFills {
    cityAutoFills {
      edges {
        node {
          id
          city
        }
      }
    }
  }
`

const SEARCH_ADDRESSES = gql`
  query searchAddresses($search: String) {
    addressAutoFills(filter: { address: { startsWith: $search } }, first: 50) {
      edges {
        node {
          id
          address
        }
      }
    }
  }
`

const SEARCH_CITIES = gql`
  query searchCities($search: String) {
    cityAutoFills(filter: { city: { startsWith: $search } }, first: 50) {
      edges {
        node {
          id
          city
        }
      }
    }
  }
`

export default {
  ADDRESSES,
  CITIES,
  SEARCH_ADDRESSES,
  SEARCH_CITIES,
}
